.modalWrapper {
  width: 600px;
}

.modalBody {
  padding-bottom: 16px;
}

.navigationTable {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.navigationTable th {
  background-color: var(--theme-secondary-background);
  padding: 12px 32px;
  text-align: left;
  border-bottom: 2px solid var(--theme-primary-border);
  font-weight: 600;
}

.navigationTable td {
  padding: 10px 32px;
  border-bottom: 1px solid var(--theme-light-border);
  vertical-align: top;
}

.navigationTable tr + tr:has(th) {
  border-top: 16px solid var(--theme-primary-background);
}
.navigationTable tr:last-child td {
  border-bottom: 0;
}
